import { isAfter as originalIsAfter, isBefore as originalIsBefore, isSameDay as originalIsSameDay, } from 'date-fns';
/**
 * 指定された日付より後か判定する
 * @param date
 * @param dateToCompare
 */
export const isAfter = (date, dateToCompare) => originalIsAfter(date, dateToCompare);
/**
 * 指定された日付より前か判定する
 * @param date
 * @param dateToCompare
 */
export const isBefore = (date, dateToCompare) => originalIsBefore(date, dateToCompare);
/**
 * 指定された日付が同じ日か判定する
 * @param date
 * @param dateToCompare
 */
export const isSameDay = (date, dateToCompare) => originalIsSameDay(date, dateToCompare);
